import { AdminReviewEditor } from "../AdminReviewEditor";

export const AdminReviewEdit = () => <AdminReviewEditor />;
